<template>
  <div class="ar">
    <div class="ar__overlay" v-if="isUploading"></div>

    <div class="ar-spinner" v-if="isUploading">
      <div class="ar-spinner__dot"></div>
      <div class="ar-spinner__dot"></div>
      <div class="ar-spinner__dot"></div>
    </div>

    <div class="ar-content" :class="{'ar__blur': isUploading}">
      <div class="ar-recorder">
        <icon-button
          class="ar-icon ar-icon__lg"
          :name="iconButtonType"
          :class="{
            'ar-icon--rec': isRecording,
            'ar-icon--pulse': isRecording && volume > 0.02
          }"
          @click.native="toggleRecorder"/>
        <icon-button
          class="ar-icon ar-icon__sm ar-recorder__stop"
          name="stop"
          @click.native="stopRecorder"/>
      </div>
      <div class="ar-recorder__duration">{{recordedTime}}</div>
      <div class="ar-recorder__time-limit" v-if="time">Длительность записи ограничена: {{time}} мин</div>
      <div class="ar-records">
         <audio v-if="audioSource.url" :ref="`questionPlayer`" controls>
          <source v-bind:src="audioSource.url">
          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
        </audio>
      </div>
      <div class="ar__upload-status">
        <button v-if="audioSource.url" class="button is-primary" v-on:click="retry">Перезаписать</button>
        <button v-if="audioSource.url" class="button is-primary" @click="$emit('confirm', audioSource)">Сохранить</button>
        <button class="button is-link" @click="$emit('close')">Закрыть</button>
      </div>
      <div :class="uploadStatusClasses" v-if="uploadStatus">{{message}}</div>
    </div>
  </div>
</template>

<script>
  import IconButton from './icon-button'
  import Recorder from './recorder'

    export default {
        name: 'audioRecorder',
        props: {
          attempts : { type: Number },
          compact  : { type: Boolean, default: false },
          time     : { type: Number },
          attemptsLimit : { type: Function },
          micFailed     : { type: Function },
          startRecord   : { type: Function },
          stopRecord    : { type: Function },
          failedUpload     : { type: Function },
          headers          : { type: Object },
          startUpload      : { type: Function },
          successfulUpload : { type: Function },
          uploadUrl        : { type: String },
          successfulUploadMsg : { type: String, default: 'Upload successful' },
          failedUploadMsg     : { type: String, default: 'Upload fail' }
        },
      data () {
        return {
          isUploading : false,
          recorder    : new Recorder({
            afterStop: () => {
              this.recordList = this.recorder.recordList()
              if (this.stopRecord) {
                this.stopRecord('stop record')
              }
            },
            attempts: this.attempts,
            time: this.time
          }),
          recordList      : [],
          selected        : {},
          uploadStatus    : null,
          uploaderOptions : {},
          audioSource : {}
        }
      },
      components: {
        IconButton
      },
      created () {
        this.uploaderOptions = {
          failedUpload     : this.failedUpload,
          headers          : this.headers,
          startUpload      : this.startUpload,
          successfulUpload : this.successfulUpload,
          uploadUrl        : this.uploadUrl
        }
        this.$watch('audioSource', function () {
          this.$refs.questionPlayer.load()
        })
      },
      beforeDestroy () {
        this.stopRecorder()
      },
      methods: {
        close () {
          this.$emit('close')
        },
        toggleRecorder () {
          if (this.attempts && this.recorder.records.length >= this.attempts) {
            return
          }
          if (!this.isRecording || (this.isRecording && this.isPause)) {
            this.recorder.start()
            if (this.startRecord) {
              this.startRecord('start record')
            }
          } else {
            this.recorder.pause()
            if (this.startRecord) {
              this.startRecord('pause record')
            }
          }
        },
        stopRecorder () {
          if (!this.isRecording) {
            return
          }
          this.recorder.stop()
          this.audioSource = this.recordList[0]
        },
        retry() {
          this.recordList.splice(0, 1)
          this.audioSource.url = null
        }
      },
      computed: {
        iconButtonType () {
          return this.isRecording && this.isPause ? 'mic' : this.isRecording ? 'pause' : 'mic'
        },
        isPause () {
          return this.recorder.isPause
        },
        isRecording () {
          return this.recorder.isRecording
        },
        message () {
          return this.uploadStatus === 'success' ? this.successfulUploadMsg : this.failedUploadMsg
        },
        recordedTime () {
          if (this.time && this.recorder.duration >= this.time * 60) {
            this.stopRecorder()
          }
          return new Date(this.recorder.duration * 1000).toISOString().substr(14, 5)
        },
        uploadStatusClasses () {
          let classes = ['ar__upload-status']
          classes.push(this.uploadStatus === 'success' ? 'ar__upload-status--success' : 'ar__upload-status--fail')
          return classes.join(' ')
        },
        volume () {
          return parseFloat(this.recorder.volume)
        }
      }
    }
</script>

<style lang="scss" scoped>

  .ar {
      width: 420px;
      height: 250px;
      font-family: 'Roboto', sans-serif;
      border-radius: 16px;
      background-color: #FAFAFA;
      box-shadow: 0 4px 18px 0 rgba(0,0,0,0.17);
      position: relative;
      box-sizing: content-box;
  &-content {
     padding: 16px;
     display: flex;
     flex-direction: column;
     align-items: center;
   }
  &-records {
     height: auto;
     padding-top: 1px;
     overflow-y: auto;
     margin-bottom: 20px;
  &__record {
     width: 320px;
     height: 45px;
     padding: 0 10px;
     margin: 0 auto;
     line-height: 45px;
     display: flex;
     justify-content: space-between;
     border-bottom: 1px solid #E8E8E8;
     position: relative;
  &--selected {
     border: 1px solid #E8E8E8;
     border-radius: 24px;
     background-color: #FFFFFF;
     margin-top: -1px;
     padding: 0 34px;
   }
  }
  }
  &-recorder {
     position: relative;
     display: flex;
     flex-direction: column;
     align-items: center;
  &__duration {
     color: #AEAEAE;
     font-size: 32px;
     font-weight: 500;
     margin-top: 20px;
     margin-bottom: 16px;
   }
  &__stop {
     position: absolute;
     top: 10px;
     right: -52px;
   }
  &__time-limit {
     position: absolute;
     color: #AEAEAE;
     font-size: 12px;
     top: 128px;
   }
  &__records-limit {
     position: absolute;
     color: #AEAEAE;
     font-size: 12px;
     top: 78px;
   }
  }
  &-spinner {
     display: flex;
     height: 30px;
     position: absolute;
     left: 0;
     right: 0;
     top: 0;
     bottom: 0;
     margin: auto;
     width: 144px;
     z-index: 10;
  &__dot {
     display: block;
     margin: 0 8px;
     border-radius: 50%;
     width: 30px;
     height: 30px;
     background: #05CBCD;
     animation-name: blink;
     animation-duration: 1.4s;
     animation-iteration-count: infinite;
     animation-fill-mode: both;
  &:nth-child(2) { animation-delay: .2s; }
  &:nth-child(3) { animation-delay: .4s; }
  @keyframes blink {
    0%    { opacity: .2; }
    20%   { opacity: 1;  }
    100%  { opacity: .2; }
  }
  }
  }
  &__text {
     color: rgba(84,84,84,0.5);
     font-size: 16px;
   }
  &__blur {
     filter: blur(2px);
     opacity: 0.7;
   }
  &__overlay {
     position: absolute;
     width: 100%;
     height: 100%;
     z-index: 10;
   }
  &__upload-status {
     text-align: center;
     font-size: 10px;
     padding: 2px;
     letter-spacing: 1px;
     position: absolute;
     bottom: 0;
  &--success {
     color: green;
   }
  &--fail {
     color: red;
   }
  }
  &__rm {
     cursor: pointer;
     position: absolute;
     width: 6px;
     height: 6px;
     padding: 6px;
     line-height: 6px;
     margin: auto;
     left: 10px;
     bottom: 0;
     top: 0;
     color: rgb(244, 120, 90);
   }
  }
   @import './scss/icons';
</style>



// WEBPACK FOOTER //
// audioRecorder.vue?afc915c4